import StatusBadge from './StatusBadge';

export default function ApplianceCard({ appliance, onClick }) {
  const borderColor = appliance.status === 'activated'
    ? 'border-l-[#06b6d4]'
    : appliance.isOnline
    ? 'border-l-[#10b981]'
    : 'border-l-[#475569]';

  return (
    <div
      className={`bg-[#0f1623] border border-[rgba(148,163,184,0.06)] rounded-[10px] p-[14px_16px] transition-all cursor-pointer border-l-[2.5px] ${borderColor} hover:border-[rgba(148,163,184,0.10)] hover:bg-[#151d2e]`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between mb-2">
        <div>
          <div className="text-[13.5px] font-semibold text-[#e2e8f0]">{appliance.unitName}</div>
        </div>
        <StatusBadge status={appliance.isOnline ? 'online' : appliance.status} />
      </div>
      <div className="flex items-center gap-3 text-[11px] text-[#475569]">
        <svg className="w-[13px] h-[13px] opacity-50" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
        </svg>
        <span>AI BOX</span>
        {appliance._count?.licenses > 0 && (
          <span className="inline-flex items-center gap-[3px] text-[10.5px] text-[#06b6d4] bg-[rgba(6,182,212,0.06)] px-[6px] py-[1px] rounded-[3px]">
            {appliance._count.licenses} licenses
          </span>
        )}
      </div>
    </div>
  );
}
